import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const asArray = (v) => (Array.isArray(v) ? v : []);

const Services = () => {
    const { t } = useTranslation();
    const cards = asArray(t('pages.home.services.cards', { returnObjects: true }));
    const moreLabel = t('pages.home.services.moreLabel');

    return (
        <div className="section-full mobile-page-padding p-t80 p-b50 bg-gray">
            <div className="section-content">
                <div className="container">
                    <div className="section-head">
                        <p className="svc-section-label">{t('pages.home.services.label')}</p>
                        <h2 className="svc-section-title">{t('pages.home.services.title')}</h2>
                    </div>

                    <div className="row">
                        {cards.map((item, index) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 m-b30" key={index}>
                                <div className="svc-card">
                                    <span className="svc-number">{item.count}</span>
                                    <h5 className="svc-title">{item.title}</h5>
                                    <p className="svc-desc">{item.description}</p>
                                    <NavLink to={item.url} className="svc-link">
                                        {moreLabel} &rarr;
                                    </NavLink>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;
